import {AfterViewInit, Component, signal} from '@angular/core';
import {BorService} from '../../../sdk/bor-api';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {TrimValidator} from '../../../utils/validators';
import {ToastrService} from '../../../shared/services/toast/toastr.service';
import {finalize} from 'rxjs';

@Component({
  selector: 'bor-report-inconsistent-psc',
  standalone: false,
  templateUrl: './report-inconsistent-psc.component.html',
  styleUrl: './report-inconsistent-psc.component.scss',
})
export class ReportInconsistentPscComponent implements AfterViewInit{

  NationalitiesList:any;

  form = new FormGroup({
    reportingName: new FormControl('', [Validators.required, TrimValidator]),
    reportingEmail: new FormControl('', [Validators.required, Validators.email]),
    reportingPhoneNumber: new FormControl('', [Validators.required]),
    companyName: new FormControl('', [Validators.required, TrimValidator]),
    companyRegistrationNumber: new FormControl('', [Validators.required, TrimValidator]),
    companyEmailAddress: new FormControl('', [Validators.email]),
    companyPhoneNumber: new FormControl('', [TrimValidator]),
    natureOfInconsistentInformation: new FormControl('', [Validators.required, TrimValidator]),
    otherNatureDetail: new FormControl('', [TrimValidator]),
    pscFirstName: new FormControl('', [Validators.required, TrimValidator]),
    pscLastName: new FormControl('', [Validators.required, TrimValidator]),
    pscOtherNames: new FormControl('', [TrimValidator]),
    pscDateOfBirth: new FormControl('', [Validators.required, TrimValidator]),
    pscIdentityDocumentType: new FormControl('', [Validators.required, TrimValidator]),
    pscNationality: new FormControl('', [Validators.required, TrimValidator]),
    additionalComments: new FormControl('', [TrimValidator]),
  });

  working = signal(false);

  constructor(private bor:BorService, private toastr: ToastrService) {
  }


  get maxDOB() {
    return (new Date()).toISOString().split('T')[0];
  }

  ngAfterViewInit() {
    this.NationalitiesList = require('../../../utils/datasets/countries.dataset').NationalitiesList
  }

  hasError(formControl: keyof typeof this.form['controls']){
    return (this.form.get(formControl)?.dirty && this.form.get(formControl)?.invalid);
  }

  sendReport(){
    if (this.working()) return;

    this.form.markAllAsDirty();
    if (this.form.invalid) {
      return this.toastr.showDanger('Some fields are either missing or invalid');
    }

    const formValue = this.form.value;

    if ((formValue.natureOfInconsistentInformation === 'OTHER') && !formValue?.otherNatureDetail?.trim()){
      return this.toastr.showDanger('Please specify the other Nature of Inconsistent Information');
    }

    this.working.set(true);

    this.bor.apiV1BorPscInconsistencyReportsPost({
      body: formValue as any
    })
      .pipe(finalize(() => this.working.set(false)))
      .subscribe({
        next: res => {
          if (!res.submittedAt){
            this.toastr.showDanger('Failed to submit report at this time. Please try again later.');
            return;
          }

          this.toastr.showSuccess('We will investigate this report shortly!', 'PSC Inconsistency Reported Successfully!');
        },
        error: err => {
          this.toastr.showDanger(err?.error?.message ?? 'Failed to submit report at this time. Please try again later.');
        }
      });
  }
}
